export default __webpack_public_path__ + "static/media/plasma.017d71b5.svg";